import TopNavThree from "../../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../../components/Header/Menu/MenuFurniture";
import Footer from "../../../components/Footer/Footer";

const PolitiqueDeConfidentialite = () => {
  document.title = "Politique de Confidentialité | Kissaria";
  return (
    <>
      {/* En-tête avec la navigation */}
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative max-sm:mb-5">
        <MenuFurniture props="bg-white" />
      </div>

      {/* Section de politique de confidentialité */}
      <div id="politique-de-confidentialite" className="container mx-auto my-10 px-5">
        <h1 className="text-3xl font-bold mb-6 text-center">Politique de Confidentialité</h1>

        {/* Introduction */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Introduction</h2>
          <p className="text-gray-700">
            Chez Kissaria, la protection de votre vie privée est une priorité. Cette politique de
            confidentialité explique comment nous collectons, utilisons, et protégeons vos données
            personnelles lorsque vous utilisez notre site web.
          </p>
        </section>

        {/* Données collectées */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Données collectées</h2>
          <p className="text-gray-700">
            Nous pouvons collecter différentes catégories de données lorsque vous utilisez notre
            site web :
          </p>
          <ul className="list-disc ml-5 mt-2 text-gray-700">
            <li>Données d'identification (nom, prénom, adresse email, etc.)</li>
            <li>Données de connexion (adresse IP, type de navigateur, etc.)</li>
            <li>Données relatives à vos achats (historique des commandes, préférences, etc.)</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Ces informations sont collectées pour vous offrir une meilleure expérience utilisateur
            et améliorer nos services.
          </p>
        </section>

        {/* Utilisation des données */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Utilisation des Données</h2>
          <p className="text-gray-700">
            Vos données personnelles sont utilisées pour :
          </p>
          <ul className="list-disc ml-5 mt-2 text-gray-700">
            <li>Traiter vos commandes et assurer le suivi de livraison</li>
            <li>Vous fournir un service client de qualité</li>
            <li>Améliorer notre site web et personnaliser votre expérience</li>
            <li>Vous envoyer des informations sur nos produits, offres, et promotions, sous réserve
              de votre consentement préalable</li>
          </ul>
        </section>

        {/* Partage des données */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Partage des Données</h2>
          <p className="text-gray-700">
            Nous ne partageons vos données personnelles qu'avec les tiers suivants :
          </p>
          <ul className="list-disc ml-5 mt-2 text-gray-700">
            <li>Prestataires de services (transporteurs, prestataires de paiement, etc.)</li>
            <li>Autorités légales, si la loi nous y oblige</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Vos données ne seront jamais vendues à des tiers pour des objectifs commerciaux sans
            votre consentement.
          </p>
        </section>

        {/* Sécurité des données */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Sécurité des Données</h2>
          <p className="text-gray-700">
            Nous prenons la sécurité de vos données très au sérieux. Nous utilisons des mesures
            techniques et organisationnelles adaptées pour protéger vos informations contre
            l'accès non autorisé, la modification, ou la suppression.
          </p>
        </section>

        {/* Vos droits */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Vos Droits</h2>
          <p className="text-gray-700">
            Conformément à la législation en vigueur, vous disposez des droits suivants concernant
            vos données personnelles :
          </p>
          <ul className="list-disc ml-5 mt-2 text-gray-700">
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification de vos données</li>
            <li>Droit de suppression de vos données</li>
            <li>Droit d'opposition au traitement de vos données</li>
            <li>Droit à la portabilité de vos données</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Pour exercer vos droits, vous pouvez nous contacter à l'adresse email indiquée dans la
            section Contact.
          </p>
        </section>

        {/* Modifications de la politique */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Modifications de la Politique</h2>
          <p className="text-gray-700">
            Cette politique de confidentialité peut être modifiée à tout moment pour refléter les
            évolutions de nos pratiques en matière de confidentialité. Nous vous encourageons à
            consulter régulièrement cette page pour vous tenir informé des mises à jour.
          </p>
        </section>

        {/* Contact */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Contact</h2>
          <p className="text-gray-700">
            Si vous avez des questions concernant cette politique de confidentialité ou si vous
            souhaitez exercer vos droits, n'hésitez pas à nous contacter à :
          </p>
          <p className="mt-4 text-gray-700">
            Email : <a href="mailto:contact@kissariti.ma" className="text-blue-500">contact@kissariti.ma</a>
          </p>
        </section>
      </div>

      {/* Pied de page */}
      <Footer />
    </>
  );
};

export default PolitiqueDeConfidentialite;